/* One quiet loading affordance, used wherever a fetch drives a list.

   Deliberately understated: this is an internal tool where most requests return in under a
   second, and a large animated spinner for 300ms reads as slowness rather than progress.
   The point is only to distinguish "still fetching" from "there is nothing here", which
   otherwise look identical. */

export function Loading({ label = 'Loading' }: { label?: string }) {
  return <p className="loading" role="status" aria-live="polite">{label}…</p>;
}

/** Chooses between loading, empty and content so callers cannot forget the first state. */
export function ListState({ loading, empty, emptyText, children }: {
  loading: boolean; empty: boolean; emptyText: string; children: React.ReactNode;
}) {
  if (loading) return <Loading />;
  if (empty) return <p className="block-empty">{emptyText}</p>;
  return <>{children}</>;
}
